var React = require('react');

function DecoElement (props) {
    return React.createElement("svg",props,React.createElement("g",{"transform":"translate(-1879.959)"},[React.createElement("rect",{"width":"40","height":"40","transform":"translate(1879.959 40) rotate(-90)","fill":"transparent","key":0}),React.createElement("rect",{"width":"20","height":"20","transform":"translate(1899.959 20) rotate(-90)","fill":"#28aae2","key":1}),React.createElement("rect",{"width":"20","height":"20","transform":"translate(1879.959 40) rotate(-90)","fill":"#6b8fca","key":2}),React.createElement("rect",{"width":"20","height":"20","transform":"translate(1900 60) rotate(-90)","fill":"#6b8fca","key":3})]));
}

DecoElement.defaultProps = {"width":"40.041","height":"60","viewBox":"0 0 40.041 60"};

module.exports = DecoElement;

DecoElement.default = DecoElement;
